import { render, staticRenderFns } from "./IsNewPage.vue?vue&type=template&id=359baa47&scoped=true"
import script from "./IsNewPage.vue?vue&type=script&lang=js"
export * from "./IsNewPage.vue?vue&type=script&lang=js"
import style0 from "./IsNewPage.vue?vue&type=style&index=0&id=359baa47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359baa47",
  null
  
)

export default component.exports